/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_JapaneseInputs */

const en_onboarding_voice_japanese = /** @type {(inputs: Onboarding_Voice_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanese`)
};

const es_onboarding_voice_japanese = /** @type {(inputs: Onboarding_Voice_JapaneseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japonés`)
};

/**
* | output |
* | --- |
* | "Japanese" |
*
* @param {Onboarding_Voice_JapaneseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_japanese = /** @type {((inputs?: Onboarding_Voice_JapaneseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_JapaneseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_japanese(inputs)
	return en_onboarding_voice_japanese(inputs)
});